<template>
  <div class="faq">
    <div class="faq-question-s" v-b-toggle.q1>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q1.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q1')}}</b-col>
      </b-row>
      <b-collapse id="q1">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A1.</b></b-col>
          <b-col cols="11">
            <div>{{$t('a1-1')}}</div>
            <br/>
            <div>{{$t('a1-2')}}</div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-e" v-b-toggle.q2>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q2.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q2')}}</b-col>
      </b-row>
      <b-collapse id="q2">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A2.</b></b-col>
          <b-col cols="11">
            <div>{{$t('a2-1')}}</div>
            <br/>
            <b-row>
              <b-col cols="1" class="bd-orange"><b>(i)</b></b-col>
              <b-col cols="11">{{$t('a2-2')}}</b-col>
            </b-row>
            <br/>
            <b-row>
              <b-col cols="1" class="bd-orange"><b>(ii)</b></b-col>
              <b-col cols="11">{{$t('a2-3')}}</b-col>
            </b-row>
            <br/>
            <div>{{$t('a2-4')}}</div>
            <br/>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-s" v-b-toggle.q3>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q3.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q3')}}</b-col>
      </b-row>
      <b-collapse id="q3">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A3.</b></b-col>
          <b-col cols="11">
            <div>{{$t('a3-1')}}</div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-e" v-b-toggle.q4>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q4.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q4')}}</b-col>
      </b-row>
      <b-collapse id="q4">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A4.</b></b-col>
          <b-col cols="11">
            <div>{{$t('a4-1')}}</div>
            <br/>
            <b-row>
              <b-col cols="1" class="bd-orange"><b>(a)</b></b-col>
              <b-col cols="11"><span v-html="$t('a4-2')"></span></b-col>
            </b-row>
            <br/>
            <b-row>
              <b-col cols="1" class="bd-orange"><b>(b)</b></b-col>
              <b-col cols="11">{{$t('a4-3')}}</b-col>
            </b-row>
            <br/>
            <b-row>
              <b-col cols="1" class="bd-orange"><b>(c)</b></b-col>
              <b-col cols="11">{{$t('a4-4')}}</b-col>
            </b-row>
            <br/>
            <b-row>
              <b-col cols="1" class="bd-orange"><b>(d)</b></b-col>
              <b-col cols="11"><span v-html="$t('a4-5')"></span></b-col>
            </b-row>
            <br/>
            <b-row>
              <b-col cols="1" class="bd-orange"><b>(e)</b></b-col>
              <b-col cols="11"><span v-html="$t('a4-6')"></span></b-col>
            </b-row>
            <br/>
            <b-row>
              <b-col cols="1" class="bd-orange"><b>(f)</b></b-col>
              <b-col cols="11">{{$t('a4-7')}}</b-col>
            </b-row>
            <br/>
            <b-row>
              <b-col cols="1" class="bd-orange"><b>(g)</b></b-col>
              <b-col cols="11">{{$t('a4-8')}}</b-col>
            </b-row>
            <br/>
            <b-row>
              <b-col cols="1" class="bd-orange"><b>(h)</b></b-col>
              <b-col cols="11">{{$t('a4-9')}}</b-col>
            </b-row>
            <br/>
            <b-row>
              <b-col cols="1" class="bd-orange"><b>(i)</b></b-col>
              <b-col cols="11">{{$t('a4-10')}}</b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-s" v-b-toggle.q5>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q5.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q5')}}</b-col>
      </b-row>
      <b-collapse id="q5">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A5.</b></b-col>
          <b-col cols="11">
            <div v-html="$t('a5-1')"></div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-e" v-b-toggle.q6>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q6.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q6')}}</b-col>
      </b-row>
      <b-collapse id="q6">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A6.</b></b-col>
          <b-col cols="11">
            <div v-html="$t('a6-1')"></div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-s" v-b-toggle.q7>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q7.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q7')}}</b-col>
      </b-row>
      <b-collapse id="q7">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A7.</b></b-col>
          <b-col cols="11">
            <div>{{$t('a7-1')}}</div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-e" v-b-toggle.q8>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q8.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q8')}}</b-col>
      </b-row>
      <b-collapse id="q8">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A8.</b></b-col>
          <b-col cols="11">
            <div v-html="$t('a8-1')"></div>
            <br/>
            <div>{{$t('a8-2')}}</div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-s" v-b-toggle.q9>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q9.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q9')}}</b-col>
      </b-row>
      <b-collapse id="q9">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A9.</b></b-col>
          <b-col cols="11">
            <div>{{$t('a9-1')}}</div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-e" v-b-toggle.q10>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q10.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q10')}}</b-col>
      </b-row>
      <b-collapse id="q10">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A10.</b></b-col>
          <b-col cols="11">
            <div>{{$t('a10-1')}}</div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-s" v-b-toggle.q11>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q11.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q11')}}</b-col>
      </b-row>
      <b-collapse id="q11">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A11.</b></b-col>
          <b-col cols="11">
            <div>{{$t('a11-1')}}</div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-e" v-b-toggle.q12>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q12.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q12')}}</b-col>
      </b-row>
      <b-collapse id="q12">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A12.</b></b-col>
          <b-col cols="11">
            <div>{{$t('a12-1')}}</div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-s" v-b-toggle.q13>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q13.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q13')}}</b-col>
      </b-row>
      <b-collapse id="q13">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A13.</b></b-col>
          <b-col cols="11">
            <div>{{$t('a13-1')}}</div>
            <br/>
            <div>{{$t('a13-2')}}</div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-e" v-b-toggle.q14>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q14.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q14')}}</b-col>
      </b-row>
      <b-collapse id="q14">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A14.</b></b-col>
          <b-col cols="11">
            <div>{{$t('a14-1')}}</div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-s" v-b-toggle.q15>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q15.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q15')}}</b-col>
      </b-row>
      <b-collapse id="q15">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A15.</b></b-col>
          <b-col cols="11">
            <div>{{$t('a15-1')}}</div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    redirectLogin() {
      this.$router.push({ name: 'Login' });
    }
  }
};
</script>

<i18n src="@/public/locales/modules/faq/components/FaqOverview.json" />